var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LelyLoginView',{on:{"authenticated":function($event){return _vm.login()}}},[_c('div',[_c('h2',{staticClass:"font-weight-normal"},[_vm._v(" HMF Admin ")]),_c('h2',{staticClass:"font-weight-light"},[_vm._v(" Please log in ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }